import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M0 6.00024H14V14.5002C14 15.3284 13.3281 16.0002 12.5 16.0002H1.5C0.671875 16.0002 0 15.3284 0 14.5002V6.00024ZM2 8.50024V9.50024C2 9.77524 2.225 10.0002 2.5 10.0002H3.5C3.775 10.0002 4 9.77524 4 9.50024V8.50024C4 8.22524 3.775 8.00024 3.5 8.00024H2.5C2.225 8.00024 2 8.22524 2 8.50024ZM2 12.5002V13.5002C2 13.7752 2.225 14.0002 2.5 14.0002H3.5C3.775 14.0002 4 13.7752 4 13.5002V12.5002C4 12.2252 3.775 12.0002 3.5 12.0002H2.5C2.225 12.0002 2 12.2252 2 12.5002ZM6 8.50024V9.50024C6 9.77524 6.225 10.0002 6.5 10.0002H7.5C7.775 10.0002 8 9.77524 8 9.50024V8.50024C8 8.22524 7.775 8.00024 7.5 8.00024H6.5C6.225 8.00024 6 8.22524 6 8.50024ZM6 12.5002V13.5002C6 13.7752 6.225 14.0002 6.5 14.0002H7.5C7.775 14.0002 8 13.7752 8 13.5002V12.5002C8 12.2252 7.775 12.0002 7.5 12.0002H6.5C6.225 12.0002 6 12.2252 6 12.5002ZM10 8.50024V9.50024C10 9.77524 10.225 10.0002 10.5 10.0002H11.5C11.775 10.0002 12 9.77524 12 9.50024V8.50024C12 8.22524 11.775 8.00024 11.5 8.00024H10.5C10.225 8.00024 10 8.22524 10 8.50024ZM10 12.5002V13.5002C10 13.7752 10.225 14.0002 10.5 14.0002H11.5C11.775 14.0002 12 13.7752 12 13.5002V12.5002C12 12.2252 11.775 12.0002 11.5 12.0002H10.5C10.225 12.0002 10 12.2252 10 12.5002Z",
			fill: "url(#paint0_linear_7940_104536)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 1C5 0.446875 4.55312 0 4 0C3.44688 0 3 0.446875 3 1V2H1.5C0.671875 2 0 2.67188 0 3.5V6H14V3.5C14 2.67188 13.3281 2 12.5 2H11V1C11 0.446875 10.5531 0 10 0C9.44687 0 9 0.446875 9 1V2H5V1Z",
			fill: "url(#paint1_linear_7940_104536)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7940_104536",
			x1: 0,
			y1: 11.0002,
			x2: 14,
			y2: 11.0002,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7940_104536",
			x1: 0,
			y1: 3,
			x2: 14,
			y2: 3,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		})] })
	]
});
export { SvgDate as ReactComponent };
